import StoreHelper from '../../../store/helper'
import PositionManager from '../../PositionManager'

import EventBus, { Events } from '../../../event-bus'

export const onDragend = (el) => {
  if (!StoreHelper.isDropTargetDefined()) {
    StoreHelper.addDragElement(StoreHelper.getActiveViewKey(), el, StoreHelper.getDragStartIndex())
  }

  // Wait for position calculation and drag events end to reset store
  setTimeout(() => { StoreHelper.resetSoft() }, 300)

  PositionManager.recalculateDropTargetPositions()

  EventBus.$emit(Events.B_MENU_ITEM_DRAG_END)
}
